import { arrayRemove, arrayUnion, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { normalizeRole } from "./roleUtils";

export const isFollowableProfile = (profile) => {
  const role = normalizeRole(profile?.role || profile?.profile?.role);
  return role === "artist" || role === "organizer";
};

export const getFollowerCount = (profile) => (profile?.followers || []).length;

export const toggleFollowProfile = async (currentUserId, targetUserId) => {
  if (!currentUserId || !targetUserId || currentUserId === targetUserId) return false;

  const currentUserRef = doc(db, "users", currentUserId);
  const targetUserRef = doc(db, "users", targetUserId);

  const [currentSnap, targetSnap] = await Promise.all([
    getDoc(currentUserRef),
    getDoc(targetUserRef),
  ]);

  if (!currentSnap.exists() || !targetSnap.exists()) return false;

  const currentFollowing = currentSnap.data().following || [];
  const isFollowing = currentFollowing.includes(targetUserId);

  await Promise.all([
    updateDoc(currentUserRef, {
      following: isFollowing ? arrayRemove(targetUserId) : arrayUnion(targetUserId),
    }),
    updateDoc(targetUserRef, {
      followers: isFollowing ? arrayRemove(currentUserId) : arrayUnion(currentUserId),
    }),
  ]);

  return !isFollowing;
};

export const notifyFollowers = async (authorId, contentType, contentId) => {
  // Placeholder for later notification wiring.
  // TODO: add a notifications collection and Firestore rules that only allow
  // followers to be updated by authenticated users and never by arbitrary client writes.
  if (!authorId || !contentType || !contentId) return null;

  return {
    authorId,
    contentType,
    contentId,
    status: "queued",
  };
};
